import { componentFactory, fcEach, datasetFactory } from '../lib/lib';
import Column3dGroup from '../datasets/groups/column.3d';

let TRUE_STRING = 'true',
  ONE_STRING = '1',
  /**
   * Filters data
   * @param {Array} data user input data
   * @return {Object} filtered data array
   */
  _dataSegregator = (data) => {
    var dataOnlyArr = [];

    fcEach(data, function (datum) {
      if (!(datum.vline === TRUE_STRING || datum.vline === true || datum.vline === 1 ||
                  datum.vline === ONE_STRING)) {
        dataOnlyArr.push(datum);
      }
    });
    return {
      data: dataOnlyArr
    };
  };
/**
 * Create dataset for 3d charts
 * @param {Object} chart Chart API
 */
export default function (chart) {
  let children = chart.getChildren(),
    canvas = children.canvas[0],
    datasetParent = canvas.getChildren('vCanvas')[0],
    dataObj = chart.getFromEnv('dataSource'),
    dataset = dataObj.dataset,
    dsType = chart.config.defaultDatasetType || '',
    data = dataObj.data || (dataset && dataset[0].data),
    DSClass,
    datasetJSON,
    groupManager3d;

  datasetJSON = _dataSegregator(data);

  if (!(data && data.length !== 0)) {
    chart.setChartMessage();
    return;
  }
  componentFactory(datasetParent, Column3dGroup, 'datasetGroup_' + dsType);
  groupManager3d = datasetParent.getChildren('datasetGroup_' + dsType)[0];

  DSClass = chart.getDSdef();
  datasetFactory(groupManager3d, DSClass, 'dataset', 1, [datasetJSON]);
}
